import { dataColors } from "@/modules/analytics/theme";

type ChartPatternBaseProps = {
  id: string;
  color?: string;
};

const Stripes = ({ id, color = dataColors.primary }: ChartPatternBaseProps): React.ReactNode => {
  return (
    <defs>
      <pattern id={id} patternUnits="userSpaceOnUse" width="4" height="4" patternTransform="rotate(45)">
        <line x1="0" y="0" x2="0" y2="6" stroke={color} strokeWidth="4" />
      </pattern>
    </defs>
  );
};

export const ChartPatterns = {
  Stripes,
};
